import React, { useState } from 'react'
import {t} from 'i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Row, Col, Button, Collapse, Card, CardBody, CardFooter } from 'reactstrap'
import { useRecoilValue } from 'recoil'
import { Accordion } from 'react-bootstrap';
import Swal from 'sweetalert2';
import axios from 'axios';

import env from '../../env/src_config';
import { headersState, tokenState } from '../../recoil/recoil';
import Spinner from '../spinner/Spinner'
import UserList from './lists/UserList'
import PaginationTop from '../Pagination/PaginationTop'
import PaginationBottom from '../Pagination/PaginationBottom'
import { isNull } from '../../izUtils'
import { axiosError } from '../../helpers/response';
import AddUpdateUser from './AddUpdateUser'
import Filter from '../filters/Filter'
import DictionaryInfoButton from '../dictionary/DictionaryInfoButton';

const UsersComponent = ({users, filters, lsFilterName, clearData, getUsers}) => {
    const Navigate = useNavigate();
    const { userId } = useParams();

    const headers = useRecoilValue(headersState);
    const tokenData = useRecoilValue(tokenState);
    const [isOpen, setIsOpen] = useState(true);

    const reset2fa = (user) => {
        axios.get(env.api + '/api/user/reset/totp/' + user.id, {headers}).then(response => {
            Swal.fire({
                text: response.data.message,
                icon: response.data.state === 'success' ? 'success' : 'error',
                confirmButtonColor: 'var(--theme-default)',
                confirmButtonText: t('ok'),
            })
        }).catch(error => {
            axiosError(error, Navigate);
        });
    }

    if (isNull(users)) {
        return <Spinner />
    } else {
        const filterFields = ['type', 'email', 'name']
        const showDictionary = {
            form: 'users',
            fields: ['type']
        }

        return (
            <Row>
                <Col md="6">
                    <Card className="ribbon-wrapper">
                        <CardBody>
                            <div className="ribbon ribbon-clip ribbon-primary">
                                <div className='d-flex align-items-center'>
                                    {t('users.list.title')}
                                    <DictionaryInfoButton code="users.list.title" id="users.list.title" />
                                </div>
                            </div>
                            <div>
                                <Accordion className='mb-3'>
                                    <div className="default-according style-1" id="userfilter">
                                        <Button color="secondary" className="acc-btn d-flex justify-content-between align-items-center" data-toggle="collapse" onClick={() => setIsOpen(!isOpen)}>
                                            {t('filters')}
                                            <div className={'filter-icon' + (isOpen ? ' rotate-icon' : '')}>
                                                <i className="fa fa-chevron-down"></i>
                                            </div>
                                        </Button>
                                        <Collapse isOpen={isOpen}>
                                            <div className='p-3'>
                                                <Filter filterFields={filterFields} filters={filters} getData={(clonedFilters) => getUsers(clonedFilters)} lsFilterName={lsFilterName} clearData={clearData} showDictionary={showDictionary} />
                                            </div>
                                        </Collapse>
                                    </div>
                                </Accordion>
                                <PaginationTop filters={filters} getData={clonedFilters => getUsers(clonedFilters)} />
                                <UserList data={users} filters={filters} reset2fa={reset2fa} />
                                <PaginationBottom filters={filters} getData={clonedFilters => getUsers(clonedFilters)} />
                            </div>
                        </CardBody>
                        {(tokenData.parsedToken.type === 'admin') &&
                            <CardFooter>
                                <div className="d-flex align-items-center mt-2">
                                    <Button color="primary" className="me-2" onClick={() => Navigate('/users/create')}>{t('users.list.addNew')}</Button>
                                    <DictionaryInfoButton code="users.list.add_new" id="users.list.add_new" />
                                </div>
                            </CardFooter>
                        }
                    </Card>
                </Col>
                <Col md="6">
                    {!isNull(userId) && <AddUpdateUser getUsers={filter => getUsers(filter)} users={users} filters={filters} />}
                </Col>
            </Row>
        )
    }
}

export default UsersComponent